/**
 * ELNKWEB-3210 - hardcoded plan cards for the not-serviceable results view.
 *
 * These are deliberately static. The serviceability API returns no products for a
 * not-serviceable address, so there is no data source to render from; the cards exist to
 * present a comparison and drive a sales call, per the requirements doc. Keeping them here
 * (rather than synthesising plan objects and pushing them through the InternetPlans
 * pipeline) keeps this view independent of the real product catalogue: no card can reach the
 * cart or emit an EEC product event. (The view does dispatch two redux actions, but only to
 * clear stale plan/bundle selections when the customer edits their address.)
 *
 * Copy is i18n-keyed. The middle card's copy is specified verbatim by the requirements doc
 * and must not be reworded. Badge labels reuse the existing productLabels.* keys so they
 * read identically to the fiber results page.
 */

export const STATIC_RESULT_CARDS = [
  {
    id: 'unstoppable-500mb',
    labelKey: 'productLabels.unstoppableSpeed',
    titleKey: 'staticPlans.unstoppableTitle',
    featureKeys: [
      'staticPlans.unstoppableFeature1',
      'staticPlans.unstoppableFeature2',
      'staticPlans.unstoppableFeature3',
      'staticPlans.unstoppableFeature4',
    ],
    highlighted: false,
    speedTier: '500 Mbps',
  },
  {
    id: 'favorite-5g-unlimited',
    labelKey: 'productLabels.customerFavorite',
    titleKey: 'staticPlans.favoriteTitle',
    featureKeys: [
      'staticPlans.favoriteFeature1',
      'staticPlans.favoriteFeature2',
      'staticPlans.favoriteFeature3',
      'staticPlans.favoriteFeature4',
    ],
    highlighted: true,
    speedTier: '425 Mbps',
  },
  {
    id: 'seamless-1gb',
    labelKey: 'productLabels.seamlessPower',
    titleKey: 'staticPlans.seamlessTitle',
    featureKeys: [
      'staticPlans.seamlessFeature1',
      'staticPlans.seamlessFeature2',
      'staticPlans.seamlessFeature3',
      'staticPlans.seamlessFeature4',
    ],
    highlighted: false,
    speedTier: '1 Gbps',
  },
];

export default STATIC_RESULT_CARDS;
